module.exports = {
    messages: {
        de:
        {
            archiv: "Archive",
            edition: "Edition",
            facsimile: "Faksimile",
            homepage: "Startseite",
            projekte: "Aufzeichnungen, Entwürfe und Fassungen",
            projekte_kurz: "Stücke",
            search: "Suchen",
            searchResults: "Suchergebnisse",
            watchlist: "Merkliste"
        },
        en:
        {
            archiv: "Archive",
            edition: "Edition",
            facsimile: "Facsimile",
            homepage: "Homepage",
            projekte: "Notes, sketches and versions",
            projekte_kurz: "Projects",
            search: "Search",
            searchResults: "Search results",
            watchlist: "Watchlist"
        },
        fr:
        {
            archiv: "Archives",
            edition: "Édition",
            facsimile: "Fac-similé",
            homepage: "Page d'accueil",
            projekte: "Brouillons et versions",
            projekte_kurz: "Projects",
            search: "Chercher",
            searchResults: "Résultats de recherche",
            watchlist: "Liste des manuscrits à retenir"
        }
    }
}
